
import request from '../util/request'

export function getAccountByPassword(data) {
  return request({
    url: 'admin/getAccountByPassword',
    method: 'post',
    data:data
  })
}


export function getEnterpriseListByUser(data) {
  return request({
    url: 'admin/getEnterpriseListByUser',
    method: 'post',
    data:data
  })
}

export function getRoleDetail(data) {
  return request({
    url: 'admin/getRoleDetail',
    method: 'post',
    data:data
  })
}

export function getAccountUserRoleDetail(data) {
  return request({
    url: 'admin/account/getAccountUserRoleDetail',
    method: 'post',
    data:data
  })
}




	







// WEBPACK FOOTER //
// ./src/api/login.js